import '../dev/reset-audit/panel';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from '@/app/providers';
import '@/shared/api/endpoints';
import '@/styles/index.css';
import { purgeNonSessionStorage } from '@/shared/utils/storage';

purgeNonSessionStorage();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
);
